export default __webpack_public_path__ + "static/winter31-c147d7c52a0605eb221b0ba6e39eaa34.webp";